<div class="page diagnostics">
  <div class="adminpanel">
    <div class="navblock">
      <div class="choosegroup" (click)="selectUsers()">
        <input type="text" readonly="readonly" [(ngModel)]="selectedUsersDesc" />
      </div>
      <app-objects-filter (onSearch)="onExtendedTermChange($event)"></app-objects-filter>
      <div>
        <button class="btn_img_large btn_dublicate_on" title="{{'Hide shared objects' | translate}}" *ngIf="UniqueOnly" (click)="setUnique(false)"></button>
        <button class="btn_img_large btn_dublicate" title="{{'Hide shared objects' | translate}}" *ngIf="!UniqueOnly" (click)="setUnique(true)"></button>

        <button class="btn_img_large btn_show_checked_off" title="{{'Hide objects status' | translate}}" *ngIf="ShowStatus" (click)="setShowStatus(false)"></button>
        <button class="btn_img_large btn_show_checked" title="{{'Hide objects status' | translate}}" *ngIf="!ShowStatus" (click)="setShowStatus(true)"></button>
      </div>
      <div></div>
      <button id="setintervalbtn" class="btn_blue" (click)="refresh()">{{'Apply'|translate }}</button>
    </div>
    <div class="tablewrap">
      <div class="table resizetable">
        <table fixedcols="[]" id="exporttable" [ngClass]="{'largeTable': ShowStatus}">
          <tr>
            <th>
                <switch-all-checkbox [items]="objects" />
            </th>
            <th class="object_column">{{'User'|translate}}</th>
            <th class="object_column">{{'Object'|translate}}</th>
            <th class="object_column">{{'IMEI'|translate}}</th>
            <th class="object_column">{{'Phone №'|translate}}</th>
            <th class="object_column">{{'Model'|translate}}</th>
            <th class="small_column">{{'Status'|translate}}</th>
            <th class="time_column">{{'Payed till'|translate}}</th>
            <th class="datetime_column">{{'Time'|translate}}</th>
            <th class="small_column" *ngIf="ShowStatus">{{'Power'|translate}}</th>
            <th class="small_column"*ngIf="ShowStatus">{{'Fuel'|translate}}</th>
            <th class="mileage_column">{{'Odometer'|translate}}</th>
            <th class="time_column"*ngIf="ShowStatus">{{'Engine time'|translate}}</th>
            <th class="small_column">{{'State'|translate}}</th>
            <th>{{'Address'|translate}}</th>
            <th></th>
          </tr>

          <tr *ngFor="let obj of getObjects(); trackBy: trackById">
            <td>
              <input type="checkbox" [(ngModel)]="obj.IsChecked"/>
            </td>
            <td>{{obj.UserName}}</td>
            <td>{{obj.Name}}</td>
            <td>{{obj.IMEI}}</td>
            <td>{{obj.Phone}}</td>
            <td>{{obj.DeviceModel | translate}}</td>
            <td [ngClass]="{'alarm': obj.Status!=1}">{{this.getStatus(obj.Status) | translate}}</td>
            <td [ngClass]="{'alarm': obj.PayedTill && obj.PayedTill < now, 'warning': obj.PayedTill && obj.PayedTill < now + day * 14}">{{obj.PayedTill | datetime:'%0D.%0M.%0Y'}}</td>
            <td [ngClass]="{'alarm': obj.Time < now - day * 7, 'warning': obj.Time < now - day}">{{obj.Time | datetime:'%0D.%0M.%0Y %0h:%0m:%0s'}}</td>
            <td *ngIf="ShowStatus" [ngClass]="{'warning': obj.LowPower || (obj.LastPower.indexOf('--') == 0)}">{{obj.LastPower}}</td>
            <td *ngIf="ShowStatus" [ngClass]="{'warning': obj.LastFuel.indexOf('--') == 0}">{{obj.LastFuel}}</td>
            <td>{{obj.Odometer | localizeKMeters}} {{'km'|localizeUnits}}</td>
            <td *ngIf="ShowStatus">{{obj.EngineTime}} {{'h' | translate}}</td>
            <td>
              <button class="btn_img btn_online" title="{{'Online' | translate}}" *ngIf="obj.Online"></button>
              <button class="btn_img btn_offline" title="{{'Offline' | translate}}" *ngIf="!obj.Online"></button>
              <button class="btn_img btn_not_fixed" title="{{'Position is not fixed' | translate}}" *ngIf="!obj.Sat && !obj.Accuracy"></button>
            </td>
            <td class="address">{{obj.Lat}} {{obj.Lng}}</td>
            <td>
              <button  *ngIf="canAccessComponent(AccessRights.EDIT)" class="btn_img btn_edit" (click)="openEditModal(obj)" title="{{'Edit'|translate}}"></button>
              <button *ngIf="obj.Owned && canAccessComponent(AccessRights.EDIT)" class="btn_img btn_trush" (click)="deleteDevice(obj)" title="{{'Delete'|translate}}"></button>
            </td>
          </tr>
          <tr>
            <th colspan="3">{{'Total'|translate}}: {{objects.length}}</th>
            <th colspan="3">{{'Blocked'|translate}}: {{blockedCount}}</th>
            <th colspan="3">{{'Irrelevant data'|translate}}: {{oldTimestampCount}}</th>
            <th *ngIf="ShowStatus"></th>
            <th *ngIf="ShowStatus"></th>
            <th *ngIf="ShowStatus"></th>
            <th></th>
            <th></th>
            <th class="address_all" colspan="2"></th>
          </tr>
        </table>
      </div>
    </div>
    <app-pagination [viewmode]="'print excel'" [printElementID]="'exporttable'">
      <div export style="display:inline-block" *ngIf="canAccessComponent(AccessRights.EDIT_ALL_USERS)">
        <div class="btn_img btn_graygray dropup btn_export-import dropclick">
          <ul>
            <li (click)="onSetPayed()">{{'Set payed period'|translate}}</li>
          </ul>
        </div>
      </div>
    </app-pagination>
  </div>
</div>
<template #mgmtDialog></template>
